import RouterView from '@/pages/RouterView'
import UserInfo from '@/pages/account/UserInfo'
import ChangePassword from '@/pages/account/ChangePassword'

import PeriodManage from '@/pages/config/PeriodManage'
import ExchangeRate from '@/pages/config/ExchangeRate'
import RentalOrganization from '@/pages/config/RentalOrganization'
import AccountRule from '@/pages/config/AccountRule'
import LoanInterestRate from '@/pages/config/LoanInterestRate'
import SystemMapping from '@/pages/config/SystemMapping'
import TaxRate from '@/pages/config/TaxRate'
import ValueSet from '@/pages/config/ValueSet'
import DataPermission from '@/pages/config/DataPermission'

import OperatePage from '@/pages/operate/OperatePage'
import UploadPOReceive from '@/pages/operate/UploadPOReceive'
import AccountingEntries from '@/pages/operate/AccountingEntries'
import ReportQuery from '@/pages/operate/ReportQuery'
import LeaseAnnotation from '@/pages/operate/LeaseAnnotation'

import UserManage from '@/pages/sys/UserManage'
import RoleManage from '@/pages/sys/RoleManage'
import LogManage from '@/pages/sys/LogManage'
import EnumManage from '@/pages/sys/EnumManage'
import MenuManage from '@/pages/sys/MenuManage'
import ButtonManage from '@/pages/sys/ButtonManage'

const dynamicRoutes = [
    {
        path: '/account',
        name: 'Account',
        code: 'ACCOUT_MANAGE',
        component: RouterView,
        children: [
        {
            path: 'UserInfo',
            name: 'UserInfo',
            code: 'USER_INFO',
            component: UserInfo,
            buttonList: []
        },{
            path: 'ChangePassword',
            name: 'ChangePassword',
            code: 'CHANGE_PASSWORD',
            component: ChangePassword,
            buttonList: []
        }
        ]
    }, {
        path: '/config',
        name: 'ConfigInterface',
        code: 'CONFIG_MANAGE',
        component: RouterView,
        children: [
        {
            path: 'PeriodManage',
            name: 'PeriodManage',
            code: 'PERIOD_MANAGE',
            component: PeriodManage,
            buttonList: []
        }, {
            path: 'ExchangeRate',
            name: 'ExchangeRate',
            code: 'EXCHANGE_RATE',
            component: ExchangeRate,
            buttonList: []
        }, {
            path: 'AccountRule',
            name: 'AccountRule',
            code: 'ACCOUNT_RULE',
            component: AccountRule,
            buttonList: []
        }, {
            path: 'RentalOrganization',
            name: 'RentalOrganization',
            code: 'RENTAL_ORGANIZATION',
            component: RentalOrganization,
            buttonList: []
        }, {
            path: 'LoanInterestRate',
            name: 'LoanInterestRate',
            code: 'LOAN_INTEREST_RATE',
            component: LoanInterestRate,
            buttonList: []
        }, {
            path: 'SystemMapping',
            name: 'SystemMapping',
            code: 'SYSTEM_MAPPING',
            component: SystemMapping,
            buttonList: []
        }, {
            path: 'TaxRate',
            name: 'TaxRate',
            code: 'TAX_RATE',
            component: TaxRate,
            buttonList: []
        }, {
            path: 'ValueSet',
            name: 'ValueSet',
            code: 'VALUE_SET',
            component: ValueSet,
            buttonList: []
        }, {
            path: 'DataPermission',
            name: 'DataPermission',
            code: 'DATA_PERMISSION',
            component: DataPermission,
            buttonList: []
        }
        ]
    }, {
        path: '/operate',
        name: 'OperateInterface',
        code: 'OPERATE_MANAGE',
        component: RouterView,
        children: [
        {
            path: 'SearchItemPage/FinanceInspect',
            name: 'FinanceInspect',
            code: 'FINANCE_INSPECT',
            component: OperatePage,
            buttonList: []
        }, {
            path: 'SearchItemPage/FinanceReview',
            name: 'FinanceReview',
            code: 'FINANCE_REVIEW',
            component: OperatePage,
            buttonList: []
        }, {
            path: 'SearchItemPage/EPOorderLeasing',
            name: 'EPOorderLeasing',
            code: 'EPO_ORDER_LEASING',
            component: OperatePage,
            buttonList: []
        }, {
            path: 'SearchItemPage/SearchPage',
            name: 'SearchPage',
            code: 'SEARCH_PAGE',
            component: OperatePage,
            buttonList: []
        }, {
            path: 'SearchItemPage/UploadOperate',
            name: 'UploadOperate',
            code: 'UPLOAD_OPERATE',
            component: OperatePage,
            buttonList: []
        }, {
            path: 'UploadPOReceive',
            name: 'UploadPOReceive',
            code: 'UPLOAD_PO_RECEIVE',
            component: UploadPOReceive,
            buttonList: []
        }, {
            path: 'SearchItemPage/ExemptOperation',
            name: 'ExemptOperation',
            code: 'EXEMPT_OPERATION',
            component: OperatePage,
            buttonList: []
        }, {
            path: 'AccountingEntries',
            name: 'AccountingEntries',
            code: 'ACCOUNTING_ENTRIES',
            component: AccountingEntries,
            buttonList: []
        }, {
            path: 'ReportQuery',
            name: 'ReportQuery',
            code: 'REPORT_QUERY',
            component: ReportQuery,
            buttonList: []
        }, 
        {
            path: 'LeaseAnnotation',
            name: 'LeaseAnnotation',
            code: 'LEASE_ANNOTATION',
            component: LeaseAnnotation,
            buttonList: []
        }
        ]
    }, {
        path: '/sys',
        name: 'SysManage',
        code: 'SYSTEM_MANAGE',
        component: RouterView,
        children: [
        {
            path: 'UserManage',
            name: 'UserManage',
            code: 'USER_MANAGE',
            component: UserManage,
            buttonList: []
        }, {
            path: 'RoleManage',
            name: 'RoleManage',
            code: 'ROLE_MANAGE',
            component: RoleManage,
            buttonList: []
        }, {
            path: 'LogManage',
            name: 'LogManage',
            code: 'LOG_MANAGE',
            component: LogManage,
            buttonList: []
        }, {
            path: 'EnumManage',
            name: 'EnumManage',
            code: 'ENUM_MANAGE',
            component: EnumManage,
            buttonList: []
        }, {
            path: 'MenuManage',
            name: 'MenuManage',
            code: 'MENU_MANAGE',
            component: MenuManage,
            buttonList: []
        }, {
            path: 'ButtonManage',
            name: 'ButtonManage',
            code: 'BUTTON_MANAGE',
            component: ButtonManage,
            buttonList: []
        }
        ]
    }
]

export default dynamicRoutes


// WEBPACK FOOTER //
// ./src/router/dynamic-router.js